import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SlovakiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15926'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15926)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33329H20V4.66663H0V9.33329Z'
					fill='#0C47B7'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#E53B35'
				/>
				<path
					d='M3.88152 9.79747L4.3039 9.29464L3.88152 9.79747L5.42813 11.0966C6.41985 11.9297 7.86676 11.9297 8.85849 11.0966L10.4051 9.79747C10.8785 9.39978 11.1414 8.80547 11.1172 8.18763L10.955 4.05495C10.9129 2.98172 10.0306 2.13338 8.95651 2.13338H5.3301C4.25605 2.13338 3.37376 2.98172 3.33164 4.05495L3.16945 8.18763C3.1452 8.80547 3.40808 9.39978 3.88152 9.79747Z'
					fill='#F73744'
					stroke='white'
					strokeWidth='1.33333'
				/>
				<mask
					id='mask1_2332_15926'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='2'
					y='1'
					width='10'
					height='12'>
					<path
						d='M3.88152 9.79747L4.3039 9.29464L3.88152 9.79747L5.42813 11.0966C6.41985 11.9297 7.86676 11.9297 8.85849 11.0966L10.4051 9.79747C10.8785 9.39978 11.1414 8.80547 11.1172 8.18763L10.955 4.05495C10.9129 2.98172 10.0306 2.13338 8.95651 2.13338H5.3301C4.25605 2.13338 3.37376 2.98172 3.33164 4.05495L3.16945 8.18763C3.1452 8.80547 3.40808 9.39978 3.88152 9.79747Z'
						fill='white'
						stroke='white'
						strokeWidth='1.33333'
					/>
				</mask>
				<g mask='url(#mask1_2332_15926)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M6.66685 7.80007C6.66685 7.61597 6.51761 7.46673 6.33352 7.46673H5.57162C5.38752 7.46673 5.23828 7.31749 5.23828 7.1334V6.86673C5.23828 6.68264 5.38752 6.5334 5.57161 6.5334H6.33352C6.51761 6.5334 6.66685 6.38416 6.66685 6.20007V5.9334C6.66685 5.7493 6.51761 5.60007 6.33352 5.60007H6.04781C5.86371 5.60007 5.71447 5.45083 5.71447 5.26673V5.00006C5.71447 4.81597 5.86371 4.66673 6.04781 4.66673H6.33352C6.51761 4.66673 6.66685 4.51749 6.66685 4.3334V4.06673C6.66685 3.88264 6.81609 3.7334 7.00019 3.7334H7.2859C7.47 3.7334 7.61923 3.88264 7.61923 4.06673V4.3334C7.61923 4.51749 7.76847 4.66673 7.95257 4.66673H8.23828C8.42238 4.66673 8.57161 4.81597 8.57161 5.00007V5.26673C8.57161 5.45083 8.42238 5.60007 8.23828 5.60007H7.95257C7.76847 5.60007 7.61923 5.7493 7.61923 5.9334V6.20006C7.61923 6.38416 7.76847 6.5334 7.95257 6.5334H8.71447C8.89857 6.5334 9.04781 6.68264 9.04781 6.86673V7.1334C9.04781 7.31749 8.89857 7.46673 8.71447 7.46673H7.95257C7.76847 7.46673 7.61923 7.61597 7.61923 7.80007V9.00006C7.61923 9.18416 7.47 9.3334 7.2859 9.3334H7.00019C6.81609 9.3334 6.66685 9.18416 6.66685 9.00007V7.80007Z'
						fill='white'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M8.00392 9.39785C7.85061 9.0837 7.52329 8.8667 7.14425 8.8667C6.76521 8.8667 6.43789 9.0837 6.28458 9.39785C5.12672 9.57663 4.28711 10.107 4.28711 10.7334C4.28711 11.5066 5.5663 12.1334 7.14425 12.1334C8.72221 12.1334 10.0014 11.5066 10.0014 10.7334C10.0014 10.107 9.16179 9.57663 8.00392 9.39785Z'
						fill='#1251A1'
					/>
				</g>
			</g>
		</svg>
	);
};

export default SlovakiaFlagIcon;
